import { ContentCopy, Check } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { ILabOrderData } from "@home-health-notify/domain/build/chat/labs/ILabOrderData";
import { useTranslation } from "hhn-commons";
import React, { useState } from "react";
import {
  OrderContainer,
  OrderHeader,
  OrderId,
  Label,
  PriorityContainer,
  StatusChip,
  CopyIconButton,
  OrderIdContainer,
} from "./LabOrderListItem.style";
import { MetadataItem } from "./LabCommon.style";
import LabReports from "./LabReports";

export interface OrderListItemProps {
  order: ILabOrderData;
}

const LabOrderListItem = ({ order }: OrderListItemProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "labRequisition" });
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (order.externalLabOrderId) {
      navigator.clipboard.writeText(order.externalLabOrderId).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "ACCEPTED":
        return "info";
      case "COMPLETED":
        return "success";
      case "FAILED":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <OrderContainer>
      <OrderHeader>
        <MetadataItem>
          <Label>{tNs("labOrderId")}</Label>
          <OrderIdContainer>
            <OrderId variant="body2">{order.externalLabOrderId}</OrderId>
            <Tooltip title={copied ? tNs("copied") : tNs("copyOrderId")}>
              <CopyIconButton size="small" onClick={handleCopy}>
                {copied ? (
                  <Check fontSize="small" />
                ) : (
                  <ContentCopy fontSize="small" />
                )}
              </CopyIconButton>
            </Tooltip>
          </OrderIdContainer>
        </MetadataItem>
      </OrderHeader>
      <PriorityContainer>
        <StatusChip
          variant="outlined"
          label={order.status}
          size="small"
          color={getStatusColor(order.status) as any}
        />
      </PriorityContainer>
      <LabReports reports={order.reports} />
    </OrderContainer>
  );
};

export default LabOrderListItem;
